import { filesRepo, FILES_TOTAL_BYTES, type FileRecord } from './files.repo'

export const filesService = {
  async list(): Promise<FileRecord[]> {
    return filesRepo.list()
  },
  async usage(): Promise<{ usedBytes: number; totalBytes: number }> {
    const usedBytes = await filesRepo.usedBytes()
    return { usedBytes, totalBytes: FILES_TOTAL_BYTES }
  },
}

export type { FileRecord } from './files.repo'
export { FILES_TOTAL_BYTES } from './files.repo'
